{
  "Audio Player": "Audio-Player",
  "Video Player": "Video-Player",
  "Play": "Laschar ir",
  "Pause": "Pausa",
  "Replay": "Mussar danovamain",
  "Current Time": "Temp actual",
  "Duration": "Durada",
  "Remaining Time": "Temp restant",
  "Stream Type": "Tip dal stream",
  "LIVE": "LIVE",
  "Loaded": "Chargià",
  "Progress": "Progress",
  "Progress Bar": "Bar da progessiun",
  "progress bar timing: currentTime={1} duration={2}": "{1} da {2}",
  "Fullscreen": "Entir visur",
  "Non-Fullscreen": "Betg entir visur",
  "Mute": "Senza tun",
  "Unmute": "Cun tun",
  "Playback Rate": "Tempo ",
  "Subtitles": "Suttitels",
  "subtitles off": "senza suttitels",
  "Captions": "Suttitels",
  "captions off": "senza suttitels",
  "Chapters": "Chapitels",
  "Descriptions": "Descripziuns",
  "descriptions off": "senza descripziuns",
  "Audio Track": "Piese audio",
  "Volume Level": "Nivel dal volumen",
  "You aborted the media playback": "Vus avais interrut il vdieo",
  "A network error caused the media download to fail part-way.": "In sbagl en la rait ha impedì il download",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Il video n'è betg chargià - ubain per in sbagl da server / da la rait, ubain ch'il format n'è betg cumpatibel.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Il video è interrut: Ubain ch'il video è donnegià, ubain che funcziuns n'èn betg cumpatiblas.",
  "No compatible source was found for this media.": "Chattà nagina funtauna cumpatibla per quest video.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Il video è codifitgà da moda nunenconuschenta.",
  "Play Video": "Aviar video",
  "Close": "Serrar",
  "Close Modal Dialog": "Serrar la fanestra modala",
  "Modal Window": "Fanestra modala",
  "This is a modal window": "Quai è ina fanestra modala",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Questa fanestra modala pudais serrar cun la tasta \"Escape\" ubain cun il buttun.",
  ", opens captions settings dialog": ", avra opziuns per ils suttitels",
  ", opens subtitles settings dialog": ", avra opziuns per ils suttitels",
  ", opens descriptions settings dialog": ", avra opziuns per la descripziun",
  ", selected": ", selecziunà",
  "captions settings": "opziuns per ils suttitels",
  "subtitles settings": "opziuns per ils suttitels",
  "descriptions settings": "opziuns per la descripziun",
  "Text": "Text",
  "White": "Alv",
  "Black": "Nair",
  "Red": "Cotschn",
  "Green": "Verd",
  "Blue": "Blau",
  "Yellow": "Mellen",
  "Magenta": "Magenta",
  "Cyan": "Cyan",
  "Background": "Fund",
  "Window": "Fanestra",
  "Transparent": "Transparent",
  "Semi-Transparent": "Mez transparent",
  "Opaque": "Betg transparent",
  "Font Size": "Grandezza dal text",
  "Text Edge Style": "Stil dal text",
  "None": "Nagin",
  "Raised": "Auzà",
  "Depressed": "Sbassà",
  "Uniform": "Uniform",
  "Dropshadow": "Sumbriva",
  "Font Family": "Scrittira",
  "Proportional Sans-Serif": "Proportionale Sans-Serif",
  "Monospace Sans-Serif": "Monospace Sans-Serif",
  "Proportional Serif": "Proportionale Serif",
  "Monospace Serif": "Monospace Serif",
  "Casual": "Casual",
  "Script": "Script",
  "Small Caps": "Bustabs pitschens",
  "Reset": "Da nov",
  "restore all settings to the default values": "Enavos tar las opziuns da standard",
  "Done": "Fatg",
  "Caption Settings Dialog": "Opziuns per suttitels",
  "Beginning of dialog window. Escape will cancel and close the window.": "Entschatta da la fanestra da dialog. Escape stizza e serra la fanestra.",
  "End of dialog window.": "Fin da la fanestra da dialog.",
  "ISO-639-1": "rm",
  "10 seconds backward": "10 seconds backward",
  "30 seconds forward": "30 seconds forward",
  "Audio": "Audio",
  "Audio and subtitles": "Audio e suttitels",
  "Audio Description": "Audio Description",
  "Auto play": "Autoplay",
  "Back": "Enavos",
  "Casting to": "Derasar via",
  "Content will be available in {1} days": "Da survegnir a {1} dìs",
  "Current position": "Posiziun actuala",
  "Current subject": "Contribuziun actuala",
  "Days": "Dìs",
  "Duration: {1}": "Durada: {1}",
  "Edit player settings": "Modifitgar ils parameters",
  "Episode": "Episoda",
  "HD": "HD",
  "Continuous Playback": "Guardar cuntinuadamain",
  "Cancel": "Annular",
  "Coming next": "Vegn bainbaud",
  "Copied": "Copià",
  "copy": "copiar",
  "Copy debug info": "Copiar las infurmaziuns dal debugar",
  "Copy link": "Copiar link",
  "Facebook": "Facebook",
  "Font size level {1}": "Nivel da grondezza da scrittira {1}",
  "Hours": "Uras",
  "Integrate": "Integrar",
  "Issue:": "Problem:",
  "LinkedIn": "LinkedIn",
  "Mail": "Mail",
  "Minutes": "Minutas",
  "Off": "Betg activ",
  "Open {1} in Play {2}": "Avrir {1} en Play {2}",
  "Playback will begin shortly": "Playback entschaiva gist",
  "Please indicate the problem below, so that we can help you.": "Inditgai p.pl. il problem qua sutvart, per che nus As possian gidar.",
  "Quality": "Qualitad",
  "Report a technical problem": "Annunziar in problem tecnic",
  "SD": "SD",
  "Seconds": "Secundas",
  "Seek to live, currently behind live": "Midar tar live - per il mument davos live",
  "Seek to live, currently playing live": "Midar tar live - per il mument live",
  "Send bug report": "Trametter il rapport da controlla",
  "Share at current position": "Cundivider a la posiziun actuala",
  "Share by e-mail": "Cundivider cun e-mail",
  "Share": "Cundivider",
  "Share on {1}": "Cundivider tar {1}",
  "Share on Facebook": "Cundivider tar Facebook",
  "Share on Linkedin": "Cundivider tar Linkedin",
  "Share on Twitter": "Cundivider tar Twitter",
  "Share on Whatsapp": "Cundivider tar Whatsapp",
  "Share on X": "Cundivider tar X",
  "Share the current subject": "Cundivider la contribuziun actuala",
  "Share the episode": "Cundivider l'entira episoda",
  "Skip credits": "Sursiglir credentials",
  "Skip intro": "Sursiglir intro",
  "Speed": "Tempo",
  "Start casting": "Cumenzar derasaziun",
  "Start pip": "Start maletg en maletg",
  "Stop": "Stop",
  "Stop casting": "Interrumper derasaziun",
  "Stop pip": "Stop maletg en maletg",
  "The content cannot be played.": "Quest cuntegn na sa betg vegnir laschà ir.",
  "This content cannot be played while using a VPN.": "Quest cuntegn na po betg vegnir reproducì cun VPN ni proxy activà.",
  "The content was skipped due to legal restriction": "Il cuntegn è vegnì eliminà per raschuns giuridicas",
  "This content is temporarily unavailable for journalistic reasons.": "Quest cuntegn na stat ad interim betg a disposiziun per motivs publicistics.",
  "This commercial media is not available.": "Quest medium commerzial n'è betg disponibel.",
  "This content is not available.": "Quest cuntegn n'è betg disponibel.",
  "This content is not available anymore.": "Quest cuntegn n'è betg pli disponibel.",
  "This content is not available due to legal restrictions.": "Quest cuntegn n'è betg disponibel perquai ch'el è scadì.",
  "This content is not available outside Switzerland.": "Quest cuntegn n'è betg disponibel ordaifer la Svizra.",
  "This content is not yet available. Please try again later.": "Quest cuntegn n'è betg anc disponibel. Empruvai pli tard.",
  "To protect children, this content is only available between 8PM and 6AM.": "Per proteger uffants, è quest cuntegn disponibel mo tranter las 20.00 e las 06.00.",
  "To protect children, this content is only available between 11PM and 5AM.": "Per proteger uffants, è quest cuntegn disponibel mo tranter las 23.00 e las 05.00.",
  "Twitter": "Twitter",
  "Unable to display the content. For more information and help, click here...": "Deplorablamain n'èsi betg pussaivel da reproducir il cuntegn. Ulteriuras infurmaziuns e sustegn survegnis Vus qua …",
  "Unfortunately the 360 playback experience is not compatible with your browser version.": "Displaschaivlamain na sustegn voss browser betg la visualisaziun da 360°.",
  "Unfortunately this format is not compatible with your browser.": "Displaschaivlamain n'è il format betg cumpatibel cun Voss apparat.",
  "WhatsApp": "WhatsApp",
  "X": "X"
}
